import { PaymentApiClient } from '@fourthwall/services/dist/PaymentApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useAddShopPaymentMethodMutation = createMutationHook(
  PaymentApiClient.addShopPaymentMethod,
  {
    mutationKey: ['addShopPaymentMethod'],
  },
)
